import { MIMES_ARCHIVO, type MimeArchivo } from "@gestiondoc/shared";

/** "Franklin Rodríguez" → "F. Rodríguez", como la segunda línea de la lista maestra. */
export function abreviarNombre(nombre: string): string {
  const partes = nombre.trim().split(/\s+/);
  if (partes.length < 2) return nombre;
  const inicial = partes[0]?.[0] ?? "";
  // Apellido: el tercer token si hay dos nombres y dos apellidos, si no el segundo.
  const apellido = partes.length >= 4 ? partes[2] : partes[1];
  return `${inicial}. ${apellido ?? ""}`.trim();
}

/** "Kensy Lara" → "KL": el avatar de la columna Lectura y del acuse. */
export function inicialesDe(nombre: string): string {
  const partes = nombre.trim().split(/\s+/);
  const primera = partes[0]?.[0] ?? "";
  const ultima = partes.length > 1 ? (partes[partes.length - 1]?.[0] ?? "") : "";
  return (primera + ultima).toUpperCase();
}

/** 24 → "2 años", 6 → "6 meses": la retención de un registro, como la lee una persona. */
export function textoDeMeses(meses: number): string {
  if (meses % 12 === 0) {
    const n = meses / 12;
    return `${n} ${n === 1 ? "año" : "años"}`;
  }
  return `${meses} meses`;
}

export function formatearTamano(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Lee un File del navegador como base64 (sin el prefijo data:). */
export function leerComoBase64(archivo: File): Promise<string> {
  return new Promise((resolver, rechazar) => {
    const lector = new FileReader();
    lector.onerror = () => rechazar(lector.error);
    lector.onload = () => {
      const r = String(lector.result);
      resolver(r.slice(r.indexOf(",") + 1));
    };
    lector.readAsDataURL(archivo);
  });
}

/** El trazo se muestra como imagen, nunca como HTML: el SVG viene de otra persona. */
export function trazoComoImagen(svg: string): string {
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

/** Mensaje de un error de tRPC o de red, listo para mostrar. */
export function mensajeDe(e: unknown): string {
  if (e && typeof e === "object" && "message" in e && typeof e.message === "string") {
    return e.message;
  }
  return "Algo salió mal. Prueba de nuevo.";
}

/** Word, Excel o PDF. Algunos navegadores no ponen el tipo: se deduce de la extensión. */
export function mimeDeArchivo(archivo: File): MimeArchivo | null {
  if (archivo.type in MIMES_ARCHIVO) return archivo.type as MimeArchivo;
  const ext = archivo.name.split(".").pop()?.toLowerCase();
  const entrada = Object.entries(MIMES_ARCHIVO).find(([, e]) => e === ext);
  return entrada ? (entrada[0] as MimeArchivo) : null;
}
